var _defs, _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWerbetafel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "1200 320 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Web_1920_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .ad { font: bold 50px sans-serif; }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_1920_1",
    "data-name": "Web 1920 \\u2013 1",
    clipPath: "url(#clip-Web_1920_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_4",
    "data-name": "Rechteck 4",
    transform: "translate(1280 343)",
    fill: "#fce810",
    stroke: "#9d9d9d",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("rect", {
    width: 419,
    height: 258,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -5,
    width: 429,
    height: 268,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    x: 1350,
    y: 450,
    fill: "#000000",
    className: "ad"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#fff;#000000",
    begin: "0s",
    dur: "0.5s",
    calcMode: "discrete",
    repeatCount: "indefinite"
  }), "\n      WERBUNG\n    "), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_5",
    "data-name": "Rechteck 5",
    width: 12,
    height: 262,
    transform: "translate(1280 609)",
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_6",
    "data-name": "Rechteck 6",
    width: 12,
    height: 262,
    transform: "translate(1687 609)",
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1",
    "data-name": "Pfad 1",
    d: "M1708.4,333.364V610.219h-9.973V871.373l7.022,6.081-.382-260.69h11.14v-276.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2",
    "data-name": "Pfad 2",
    d: "M1708.978,610.161l7.435,6.589h-11.273l-7.034-6.589Z",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3",
    "data-name": "Pfad 3",
    d: "M1687,871h11.448l7.066,6.587h-10.939Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4",
    "data-name": "Pfad 4",
    d: "M1687,616.75H1298.4l-6.578-5.767H1687Z",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5",
    "data-name": "Pfad 5",
    d: "M1292,610.983l6.345,5.727.081,259.948-6.805-5.543Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6",
    "data-name": "Pfad 6",
    d: "M1280,610.983h-10.131l6.524,5.469H1280Z",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7",
    "data-name": "Pfad 7",
    d: "M1291.5,871h-11.586l6.742,5.737h11.851Z",
    fill: "#5f5f5f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWerbetafel);
export default __webpack_public_path__ + "static/media/werbetafel.ec21c6fb39d5df4e21a891c2e7fcb27b.svg";
export { ForwardRef as ReactComponent };